const locale = {
    "ru": {
        title: "Условные обозначения",
        colorArea: {
            label: "Цвет области",
            min: "Мин",
            max: "Макс",
            notDefined: "Не определено"
        },
        noDataCell: {
            label: "Ячейка без данных",
            description: "Нет данных"
        },
        gradient: {
            from: "от",
            to: "до"
        }
    },
    "en": {
        title: "Legend",
        colorArea: {
            label: "Area color",
            min: "Min",
            max: "Max",
            notDefined: "Not defined"
        },
        noDataCell: {
            label: "Cell without data",
            description: "No data"
        },
        gradient: {
            from: "from",
            to: "to"
        }
    }
};

export default locale;